'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroDivider = require('./NitroDivider');

var _NitroDivider2 = _interopRequireDefault(_NitroDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroDivider2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-divider/index.js
// module id = 33
// module chunks = 4